import { useTranslation } from "react-i18next";

interface Props {
  blocking?: boolean;
}

export function ReKeyBanner({ blocking = false }: Props) {
  const { t } = useTranslation();
  const message = blocking ? t("rekey.blocking") : t("rekey.banner");

  return (
    <div
      role="alert"
      aria-live="assertive"
      className={`w-full px-6 py-3 text-center text-white font-medium ${
        blocking ? "bg-red-700 text-lg" : "bg-amber-600 text-base"
      }`}
    >
      {message}
    </div>
  );
}
